import { User } from 'src/app/shared/models/fusion-auth/user';
import { All, FusionAuthActionTypes } from '../actions/fusion-auth.actions';

export interface State {
    isAuthenticated: boolean;
    isLoading: boolean;
    user: User | null;
    state: string | null;
    token: string | null;
    refreshToken: string | null;
    errorMessage: string | null;
}

export const initialState: State = {
    isAuthenticated: false,
    isLoading: false,
    user: null,
    state: null,
    token: null,
    refreshToken: null,
    errorMessage: null,
};

export function reducer(state = initialState, action: All): State {
    switch (action.type) {
        case FusionAuthActionTypes.LOGIN: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case FusionAuthActionTypes.LOGIN_SUCCESS: {
            return {
                ...state,
                isAuthenticated: true,
                isLoading: false,
                user: action.payload.user,
                token: action.payload.token,
                state: action.payload.state,
                refreshToken: action.payload.refreshToken,
                errorMessage: null,
            };
        }
        case FusionAuthActionTypes.LOGIN_FAILURE: {
            return {
                ...state,
                isLoading: false,
                errorMessage: 'Incorrect email and/or password.',
            };
        }
        case FusionAuthActionTypes.LOGOUT: {
            return initialState;
        }
        default: {
            return state;
        }
    }
}
